/**
 * @generated SignedSource<<f1f0fdbfa4db4f6a9aedbc80a98c5e68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectDuplicateInput = {
  date: string;
  name: string;
  new_project_input?: NewProjectInput | null | undefined;
  original_project_id: number;
};
export type NewProjectInput = {
  client_id?: number | null | undefined;
  client_name?: string | null | undefined;
  confirmed: boolean;
  custom_values?: ProjectInputCustomValues | null | undefined;
  emoji?: string | null | undefined;
  is_template: boolean;
  links?: ReadonlyArray<PersonInputLink> | null | undefined;
  manager_ids?: ReadonlyArray<number | null | undefined> | null | undefined;
  pricing_model: string;
  rate_card_id: number;
  references?: any | null | undefined;
  tags?: ReadonlyArray<string | null | undefined> | null | undefined;
  team_id?: number | null | undefined;
  workstreams?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type ProjectInputCustomValues = {
  checkbox?: ReadonlyArray<ProjectInputCustomValuesCheckbox | null | undefined> | null | undefined;
  date?: ReadonlyArray<ProjectInputCustomValuesDate | null | undefined> | null | undefined;
  select?: ReadonlyArray<ProjectInputCustomValuesSelect | null | undefined> | null | undefined;
  text?: ReadonlyArray<ProjectInputCustomValuesText | null | undefined> | null | undefined;
};
export type ProjectInputCustomValuesCheckbox = {
  typeId: number;
  value: boolean;
};
export type ProjectInputCustomValuesDate = {
  typeId: number;
  value?: string | null | undefined;
};
export type ProjectInputCustomValuesSelect = {
  optionId: number;
  typeId: number;
};
export type ProjectInputCustomValuesText = {
  typeId: number;
  value: string;
};
export type PersonInputLink = {
  href: string;
  id?: number | null | undefined;
  name: string;
  show_in_planner: boolean;
};
export type ProjectDuplicateMutation$variables = {
  includeProjectTemplates: boolean;
  input: ProjectDuplicateInput;
  plannerStartDate: any;
  todaysDate: any;
};
export type ProjectDuplicateMutation$data = {
  readonly action_project_duplicate: {
    readonly account: {
      readonly id: number;
      readonly people: ReadonlyArray<{
        readonly account_id: number;
        readonly active: boolean;
        readonly archivable: boolean | null | undefined;
        readonly assignments: ReadonlyArray<{
          readonly id: number;
        }>;
        readonly competencies: ReadonlyArray<{
          readonly id: number;
          readonly level: number | null | undefined;
          readonly person_id: number;
          readonly skill: {
            readonly id: number;
            readonly name: string;
          };
          readonly skill_id: number;
        }>;
        readonly contracts: ReadonlyArray<{
          readonly cost: number | null | undefined;
          readonly employment_type: string;
          readonly end_date: string | null | undefined;
          readonly id: number;
          readonly job_title: string | null | undefined;
          readonly minutes_per_day: number | null | undefined;
          readonly role: {
            readonly id: number;
            readonly name: string;
          };
          readonly role_id: number;
          readonly start_date: string | null | undefined;
        }>;
        readonly custom_checkbox_values: ReadonlyArray<{
          readonly id: number;
          readonly typeId: number;
          readonly value: boolean;
        }>;
        readonly custom_date_values: ReadonlyArray<{
          readonly id: number;
          readonly typeId: number;
          readonly value: any | null | undefined;
        }>;
        readonly custom_select_values: ReadonlyArray<{
          readonly id: number;
          readonly optionId: number;
          readonly typeId: number;
        }>;
        readonly custom_text_values: ReadonlyArray<{
          readonly id: number;
          readonly typeId: number;
          readonly value: string;
        }>;
        readonly email: string | null | undefined;
        readonly first_name: string;
        readonly id: number;
        readonly is_placeholder: boolean;
        readonly last_name: string;
        readonly people_notes: ReadonlyArray<{
          readonly id: number;
        }>;
        readonly person_requests: ReadonlyArray<{
          readonly id: number;
        }>;
        readonly placeholder_suggestions: ReadonlyArray<{
          readonly suggested_person_id: number;
        }>;
        readonly project_memberships: ReadonlyArray<{
          readonly has_actuals: boolean | null | undefined;
          readonly id: number;
          readonly project: {
            readonly id: number;
            readonly is_template: boolean;
          };
          readonly project_id: number;
          readonly role_id: number;
          readonly workstream_id: number | null | undefined;
        }>;
        readonly references: any;
        readonly tags: any;
        readonly team: {
          readonly id: number;
        } | null | undefined;
        readonly team_id: number | null | undefined;
        readonly time_offs: ReadonlyArray<{
          readonly id: number;
        }>;
      }>;
      readonly projectTemplates?: ReadonlyArray<{
        readonly client: {
          readonly id: number;
          readonly image_key: string | null | undefined;
          readonly name: string;
          readonly website: string | null | undefined;
        };
        readonly id: number;
        readonly name: string;
        readonly pricing_model: string;
        readonly pricing_model_readable: string | null | undefined;
        readonly tags: any | null | undefined;
        readonly team: {
          readonly id: number;
          readonly name: string;
        } | null | undefined;
        readonly workstreams_computed: any | null | undefined;
      }>;
      readonly projects: ReadonlyArray<{
        readonly id: number;
        readonly is_template: boolean;
      }>;
      readonly workstreams: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly project: {
      readonly account_id: number;
      readonly active: boolean;
      readonly actuals_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly archivable: boolean | null | undefined;
      readonly assignments: ReadonlyArray<{
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly is_billable: boolean | null | undefined;
        readonly is_template: boolean;
        readonly minutes_per_day: number;
        readonly non_working_day: boolean;
        readonly note: string | null | undefined;
        readonly person_id: number;
        readonly phase_id: number | null | undefined;
        readonly project_id: number;
        readonly role_id: number;
        readonly start_date: string | null | undefined;
        readonly updated_at: string;
        readonly workstream_id: number | null | undefined;
      }>;
      readonly assignments_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly calc_end_date: string | null | undefined;
      readonly calc_start_date: string | null | undefined;
      readonly client: {
        readonly active: boolean;
        readonly id: number;
        readonly image_key: string | null | undefined;
        readonly name: string;
      };
      readonly client_id: number;
      readonly confirmed: boolean;
      readonly created_at: string;
      readonly custom_checkbox_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: boolean;
      }>;
      readonly custom_date_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: any | null | undefined;
      }>;
      readonly custom_select_values: ReadonlyArray<{
        readonly optionId: number;
        readonly typeId: number;
      }>;
      readonly custom_text_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: string;
      }>;
      readonly emoji: string | null | undefined;
      readonly expenses_budget: number | null | undefined;
      readonly future_assignments_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly id: number;
      readonly links: ReadonlyArray<{
        readonly href: string;
        readonly id: number;
        readonly name: string;
        readonly show_in_planner: boolean;
      }>;
      readonly managers: ReadonlyArray<{
        readonly id: number;
        readonly project: {
          readonly id: number;
        };
        readonly user_id: number;
      }>;
      readonly members: ReadonlyArray<{
        readonly id: number;
        readonly person: {
          readonly active: boolean;
          readonly id: number;
        };
        readonly person_id: number;
        readonly project_id: number;
        readonly role_id: number;
        readonly workstream_id: number | null | undefined;
      }>;
      readonly milestones: ReadonlyArray<{
        readonly date: string | null | undefined;
        readonly icon: string | null | undefined;
        readonly id: number;
        readonly note: string | null | undefined;
        readonly project_id: number;
        readonly title: string | null | undefined;
      }>;
      readonly name: string;
      readonly other_costs: ReadonlyArray<{
        readonly charge: number;
        readonly cost: number;
        readonly date: string | null | undefined;
        readonly id: number;
        readonly name: string;
        readonly project_id: number;
      }>;
      readonly phases: ReadonlyArray<{
        readonly color: string;
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly name: string;
        readonly project_id: number;
        readonly start_date: string | null | undefined;
      }>;
      readonly pricing_model: string;
      readonly pricing_model_readable: string | null | undefined;
      readonly project_rates: ReadonlyArray<{
        readonly id: number;
        readonly project_id: number;
        readonly rate: number | null | undefined;
        readonly role_id: number;
      }>;
      readonly project_roles: ReadonlyArray<{
        readonly estimated_minutes: number | null | undefined;
        readonly id: number;
        readonly project_id: number;
        readonly role_id: number;
      }>;
      readonly project_workstreams: ReadonlyArray<{
        readonly workstream: {
          readonly archived: boolean;
          readonly id: number;
          readonly name: string;
        };
      }>;
      readonly rate_card: {
        readonly blended_rate: number | null | undefined;
        readonly blended_rate_card: boolean;
        readonly id: number;
        readonly name: string | null | undefined;
        readonly role_charge_out_rates: ReadonlyArray<{
          readonly charge_out_rate: number | null | undefined;
          readonly rate_card_id: number;
          readonly role_id: number;
        }>;
      };
      readonly rate_card_id: number;
      readonly references: any;
      readonly tags: any | null | undefined;
      readonly team: {
        readonly id: number;
        readonly name: string;
      } | null | undefined;
      readonly team_id: number | null | undefined;
      readonly total_budget: number | null | undefined;
      readonly workstreams_computed: any | null | undefined;
    } | null | undefined;
  };
};
export type ProjectDuplicateMutation = {
  response: ProjectDuplicateMutation$data;
  variables: ProjectDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeProjectTemplates"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plannerStartDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todaysDate"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account_id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "references",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team_id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstreams_computed",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model_readable",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate_card_id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivable",
  "storageKey": null
},
v16 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "_gte",
            "variableName": "plannerStartDate"
          }
        ],
        "kind": "ObjectValue",
        "name": "end_date_iso"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "person_id",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "project_id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstream_id",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v22 = {
  "alias": "start_date",
  "args": null,
  "kind": "ScalarField",
  "name": "start_date_runn",
  "storageKey": null
},
v23 = {
  "alias": "end_date",
  "args": null,
  "kind": "ScalarField",
  "name": "end_date_runn",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutes_per_day",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_template",
  "storageKey": null
},
v26 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "archived",
    "storageKey": null
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image_key",
  "storageKey": null
},
v28 = [
  (v4/*: any*/)
],
v29 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "teams",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": "date",
  "args": null,
  "kind": "ScalarField",
  "name": "date_runn",
  "storageKey": null
},
v32 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v33 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "assignments_aggregate_fields",
    "kind": "LinkedField",
    "name": "aggregate",
    "plural": false,
    "selections": (v32/*: any*/),
    "storageKey": null
  }
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v35 = {
  "alias": "typeId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_text_type_id",
  "storageKey": null
},
v36 = {
  "alias": "typeId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_date_type_id",
  "storageKey": null
},
v37 = {
  "alias": "optionId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_select_option_id",
  "storageKey": null
},
v38 = {
  "alias": "typeId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_select_type_id",
  "storageKey": null
},
v39 = {
  "alias": "typeId",
  "args": null,
  "kind": "ScalarField",
  "name": "custom_checkbox_type_id",
  "storageKey": null
},
v40 = [
  (v4/*: any*/),
  (v25/*: any*/)
],
v41 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProjectDuplicateOutput",
    "kind": "LinkedField",
    "name": "action_project_duplicate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "client_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calc_end_date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calc_start_date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created_at",
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "confirmed",
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": "total_budget",
            "args": null,
            "kind": "ScalarField",
            "name": "total_budget_private",
            "storageKey": null
          },
          {
            "alias": "expenses_budget",
            "args": null,
            "kind": "ScalarField",
            "name": "expenses_budget_private",
            "storageKey": null
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emoji",
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": "assignments",
            "kind": "LinkedField",
            "name": "assignments",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phase_id",
                "storageKey": null
              },
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "is_billable",
                "storageKey": null
              },
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "non_working_day",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updated_at",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_roles",
            "kind": "LinkedField",
            "name": "project_roles",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimated_minutes",
                "storageKey": null
              },
              (v18/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_workstreams",
            "kind": "LinkedField",
            "name": "project_workstreams",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "workstreams",
                "kind": "LinkedField",
                "name": "workstream",
                "plural": false,
                "selections": (v26/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "clients",
            "kind": "LinkedField",
            "name": "client",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v5/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_managers",
            "kind": "LinkedField",
            "name": "managers",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "user_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "projects",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v30/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "milestones",
            "kind": "LinkedField",
            "name": "milestones",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v31/*: any*/),
              (v18/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_members",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v18/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "people",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_rates",
            "kind": "LinkedField",
            "name": "project_rates",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v19/*: any*/),
              (v18/*: any*/),
              {
                "alias": "rate",
                "args": null,
                "kind": "ScalarField",
                "name": "rate_private",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "phases",
            "kind": "LinkedField",
            "name": "phases",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "order_by",
                "value": {
                  "date": "asc"
                }
              }
            ],
            "concreteType": "other_costs",
            "kind": "LinkedField",
            "name": "other_costs",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "charge",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cost",
                "storageKey": null
              },
              (v31/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "rate_cards",
            "kind": "LinkedField",
            "name": "rate_card",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": "blended_rate",
                "args": null,
                "kind": "ScalarField",
                "name": "blended_rate_private",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blended_rate_card",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "role_charge_out_rates",
                "kind": "LinkedField",
                "name": "role_charge_out_rates",
                "plural": true,
                "selections": [
                  (v19/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": "charge_out_rate",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "charge_out_rate_private",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "actuals_aggregate",
            "kind": "LinkedField",
            "name": "actuals_aggregate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "actuals_aggregate_fields",
                "kind": "LinkedField",
                "name": "aggregate",
                "plural": false,
                "selections": (v32/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "assignments_aggregate",
            "kind": "LinkedField",
            "name": "assignments_aggregate",
            "plural": false,
            "selections": (v33/*: any*/),
            "storageKey": null
          },
          {
            "alias": "future_assignments_aggregate",
            "args": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "_gte",
                        "variableName": "todaysDate"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "end_date_iso"
                  }
                ],
                "kind": "ObjectValue",
                "name": "where"
              }
            ],
            "concreteType": "assignments_aggregate",
            "kind": "LinkedField",
            "name": "assignments_aggregate",
            "plural": false,
            "selections": (v33/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "project_links",
            "kind": "LinkedField",
            "name": "links",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "href",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "show_in_planner",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "custom_text_values",
            "kind": "LinkedField",
            "name": "custom_text_values",
            "plural": true,
            "selections": [
              (v34/*: any*/),
              (v35/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "custom_date_values",
            "kind": "LinkedField",
            "name": "custom_date_values",
            "plural": true,
            "selections": [
              (v34/*: any*/),
              (v36/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "custom_select_values",
            "kind": "LinkedField",
            "name": "custom_select_values",
            "plural": true,
            "selections": [
              (v37/*: any*/),
              (v38/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "custom_checkbox_values",
            "kind": "LinkedField",
            "name": "custom_checkbox_values",
            "plural": true,
            "selections": [
              (v34/*: any*/),
              (v39/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "projects",
            "plural": true,
            "selections": (v40/*: any*/),
            "storageKey": null
          },
          {
            "condition": "includeProjectTemplates",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "projectTemplates",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "is_template": {
                        "_eq": true
                      }
                    }
                  }
                ],
                "concreteType": "projects",
                "kind": "LinkedField",
                "name": "projects",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "clients",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "website",
                        "storageKey": null
                      },
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v30/*: any*/)
                ],
                "storageKey": "projects(where:{\"is_template\":{\"_eq\":true}})"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "people",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "first_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "last_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "is_placeholder",
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/),
              (v7/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "contracts",
                "kind": "LinkedField",
                "name": "contracts",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employment_type",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "alias": "cost",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cost_private",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "roles",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "job_title",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "competencies",
                "kind": "LinkedField",
                "name": "competencies",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "skill_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "level",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "skills",
                    "kind": "LinkedField",
                    "name": "skill",
                    "plural": false,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "time_offs",
                "kind": "LinkedField",
                "name": "time_offs",
                "plural": true,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "teams",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "assignments",
                "kind": "LinkedField",
                "name": "assignments",
                "plural": true,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "people_notes",
                "kind": "LinkedField",
                "name": "people_notes",
                "plural": true,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_text_values",
                "kind": "LinkedField",
                "name": "custom_text_values",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_select_values",
                "kind": "LinkedField",
                "name": "custom_select_values",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_checkbox_values",
                "kind": "LinkedField",
                "name": "custom_checkbox_values",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v39/*: any*/),
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "custom_date_values",
                "kind": "LinkedField",
                "name": "custom_date_values",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v36/*: any*/),
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_members",
                "kind": "LinkedField",
                "name": "project_memberships",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "has_actuals",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "projects",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": (v40/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "person_requests",
                "kind": "LinkedField",
                "name": "person_requests",
                "plural": true,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "placeholder_suggestions",
                "kind": "LinkedField",
                "name": "placeholder_suggestions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "suggested_person_id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "workstreams",
            "kind": "LinkedField",
            "name": "workstreams",
            "plural": true,
            "selections": (v26/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectDuplicateMutation",
    "selections": (v41/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectDuplicateMutation",
    "selections": (v41/*: any*/)
  },
  "params": {
    "cacheID": "6645b017d262f7ceddb57395cd816bd8",
    "id": null,
    "metadata": {},
    "name": "ProjectDuplicateMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectDuplicateMutation(\n  $input: ProjectDuplicateInput!\n  $todaysDate: date!\n  $plannerStartDate: date!\n  $includeProjectTemplates: Boolean!\n) {\n  action_project_duplicate(input: $input) {\n    project {\n      id\n      name\n      active\n      account_id\n      client_id\n      calc_end_date\n      calc_start_date\n      created_at\n      references\n      team_id\n      confirmed\n      tags\n      workstreams_computed\n      pricing_model\n      pricing_model_readable\n      total_budget: total_budget_private\n      expenses_budget: expenses_budget_private\n      rate_card_id\n      emoji\n      archivable\n      assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        person_id\n        project_id\n        role_id\n        phase_id\n        workstream_id\n        note\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        is_billable\n        is_template\n        non_working_day\n        updated_at\n      }\n      project_roles {\n        id\n        estimated_minutes\n        project_id\n        role_id\n      }\n      project_workstreams {\n        workstream {\n          id\n          name\n          archived\n        }\n      }\n      client {\n        id\n        active\n        name\n        image_key\n      }\n      managers {\n        id\n        user_id\n        project {\n          id\n        }\n      }\n      team {\n        id\n        name\n      }\n      milestones {\n        id\n        date: date_runn\n        project_id\n        note\n        icon\n        title\n      }\n      members {\n        id\n        project_id\n        person_id\n        role_id\n        workstream_id\n        person {\n          id\n          active\n        }\n      }\n      project_rates {\n        id\n        role_id\n        project_id\n        rate: rate_private\n      }\n      phases {\n        id\n        name\n        start_date: start_date_runn\n        end_date: end_date_runn\n        color\n        project_id\n      }\n      other_costs(order_by: {date: asc}) {\n        id\n        project_id\n        charge\n        cost\n        date: date_runn\n        name\n      }\n      rate_card {\n        id\n        name\n        blended_rate: blended_rate_private\n        blended_rate_card\n        role_charge_out_rates {\n          role_id\n          rate_card_id\n          charge_out_rate: charge_out_rate_private\n        }\n      }\n      actuals_aggregate {\n        aggregate {\n          count\n        }\n      }\n      assignments_aggregate {\n        aggregate {\n          count\n        }\n      }\n      future_assignments_aggregate: assignments_aggregate(where: {end_date_iso: {_gte: $todaysDate}}) {\n        aggregate {\n          count\n        }\n      }\n      links {\n        id\n        name\n        href\n        show_in_planner\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        value\n        typeId: custom_checkbox_type_id\n      }\n    }\n    account {\n      id\n      projects {\n        id\n        is_template\n      }\n      projectTemplates: projects(where: {is_template: {_eq: true}}) @include(if: $includeProjectTemplates) {\n        id\n        name\n        pricing_model\n        pricing_model_readable\n        tags\n        workstreams_computed\n        client {\n          id\n          name\n          website\n          image_key\n        }\n        team {\n          id\n          name\n        }\n      }\n      people {\n        id\n        active\n        first_name\n        last_name\n        email\n        is_placeholder\n        team_id\n        tags\n        references\n        account_id\n        archivable\n        contracts {\n          id\n          start_date: start_date_runn\n          end_date: end_date_runn\n          minutes_per_day\n          employment_type\n          role_id\n          cost: cost_private\n          role {\n            id\n            name\n          }\n          job_title\n        }\n        competencies {\n          id\n          person_id\n          skill_id\n          level\n          skill {\n            id\n            name\n          }\n        }\n        time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n          id\n        }\n        team {\n          id\n        }\n        assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n          id\n        }\n        people_notes {\n          id\n        }\n        custom_text_values {\n          id\n          value\n          typeId: custom_text_type_id\n        }\n        custom_select_values {\n          id\n          optionId: custom_select_option_id\n          typeId: custom_select_type_id\n        }\n        custom_checkbox_values {\n          id\n          typeId: custom_checkbox_type_id\n          value\n        }\n        custom_date_values {\n          id\n          typeId: custom_date_type_id\n          value\n        }\n        project_memberships {\n          id\n          has_actuals\n          role_id\n          workstream_id\n          project_id\n          project {\n            id\n            is_template\n          }\n        }\n        person_requests {\n          id\n        }\n        placeholder_suggestions {\n          suggested_person_id\n        }\n      }\n      workstreams {\n        id\n        name\n        archived\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d42a213f4cdfdaa24da916cdd929b04";

export default node;
